import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

// Services
import useExtraService from '../../../../../../../services/extraService';

// Components
import InputField from '../../../../../../atoms/InputField/InputField';
import TagsInput from '../../../../../../molecules/TagsInput/TagsInput';
import SkeletonLoader from '../../../../../../molecules/SkeletonLoader/SkeletonLoader';

function General({ formik }) {
  const { t } = useTranslation();

  const { getExtraTypes } = useExtraService();

  const { data: types, isLoading: isTypesLoading } = useQuery('getTypes', getExtraTypes);

  const getInput = useCallback((name) => (
    <div className="m-b-15">
      <InputField
        id={`extra_marketing_${name}`}
        name={name}
        value={formik.values[name]}
        label={t(`extras.marketing.form.${name}`)}
        formik={{
          handleChange: formik.handleChange,
          handleBlur: formik.handleBlur,
        }}
        error={formik.errors?.[name] && formik.touched?.[name] ? formik.errors[name] : null}
        isRequired
        full
      />
    </div>
  ), [formik]);

  const getInputTags = (name, options, isLoading, transKeyForOptions) => (
    isLoading ? (
      <div className="d-flex f-wrap">
        <SkeletonLoader width={100} height={40} className="m-r-10" radius={40} />
        <SkeletonLoader width={100} height={40} className="m-r-10" radius={40} />
        <SkeletonLoader width={100} height={40} className="m-r-10" radius={40} />
      </div>
    ) : (
      options?.length ? (
        <TagsInput
          name={name}
          options={options.map((option) => ({ label: t(`${transKeyForOptions}.${option}`), value: option }))}
          selected={formik.values[name]}
          setFieldValue={formik.setFieldValue}
          setFieldTouched={formik.setFieldTouched}
          error={formik.errors?.[name] && formik.touched?.[name] ? formik.errors[name] : null}
        />
      ) : null
    )
  );

  return (
    <div>
      <h3 className="fs-20 m-b-25">{t('extras.marketing.sub.informations')}</h3>

      <div className="input_max">
        {getInput('name')}
      </div>

      <hr className="m-t-30 m-b-40" />

      <h3 className="fs-20 m-b-25">
        {t('extras.marketing.sub.type')}
        <span className="c-primary-500 m-l-5 fs-18">*</span>
      </h3>

      <div className="input_max">
        {getInputTags('type', types?.data?.extraTypes, isTypesLoading, 'extras.types')}
      </div>
    </div>
  );
}

General.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      isNovelty: PropTypes.bool,
      name: PropTypes.string,
      sport: PropTypes.shape({}),
      type: PropTypes.shape({}),
    }),
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    errors: PropTypes.shape({}),
    touched: PropTypes.shape({}),
  }).isRequired,
};

export default General;
